import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Left from "../../../constants/home/aBetterWay-options-left"
import Right from "../../../constants/home/aBetterWay-options-right"
import Item from "./item"

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "abetterway" } }
      sort: { fields: name }
    ) {
      nodes {
        relativeDirectory
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const ABetterWay = () => {
  const data = useStaticQuery(query)
  const {
    allFile: { nodes: images },
  } = data
  return (
    <Wrapper>
      <div className="section-center">
        <h2>A better way to work</h2>
        <div className="content">
          <div>
          <h3>The old way</h3>
          <div className="left">
            {Left.map((item, index) => {
              return <Item key={index} item={item} image={images[index]} />
            })}
          </div>
          </div>
          <div>
          <h3 className="tssw">The Shopify Systems way</h3>
          <div className="right">
            {Right.map((item, index) => {
              return <Item key={index} item={item} image={images[index + 3]} />
            })}
          </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin-bottom: 150px;
  
  .section-center {
      width: 100vw;
  }
  
  h2 {
    font-size: 28px;
    margin-bottom: 2rem;
    margin-left: 20px;
  }
  h3 {
    font-size: 26px;
    margin-top: 0px;
    margin-bottom: 26px;
    margin-left: 20px;
  }

  .right { 
    background: var(--clr-white);
    border-radius: 10px;
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
    padding: 20px 0;
  }

  @media screen and (min-width: 360px) {    
    .section-center{width: 85vw}
  }
  @media screen and (min-width: 768px) {
    .tssw {margin-top: 2rem;}
  }
  @media screen and (min-width: 1024px) {    
    .section-center{width: 95vw}
    .tssw {margin-top: 0;}
  }

@media screen and (min-width: 1025px) {
  margin-bottom: 10rem;
  h2 {
    font-size: 46px;
line-height: 72px;
    margin-bottom: 2rem;
  }
  h3 {
    margin-bottom: 3rem;
  }
  .content {display: flex;}
  .left {
    
    padding: 3.25rem;
    flex-basis: 50%;
    
  }
  .right {
    background: var(--clr-white);
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
    padding: 3.25rem;
    flex-basis: 50%;
    
  }
}
`

export default ABetterWay
